import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listChannelTypes, listChannelConfigs } from '../../api/crmApi';

import { channelsKeys } from './keys';

export const channelTypesOptions = (includeInactive = false) =>
	queryOptions({
		queryKey: channelsKeys.types(includeInactive),
		queryFn: async () => {
			const res = await listChannelTypes(includeInactive);
			return res.channelTypes ?? [];
		},
		staleTime: STALE_TIMES.STABLE, // Channel types rarely change, long cache is fine
	});

export function useChannelTypes(includeInactive = false) {
	return useQuery(channelTypesOptions(includeInactive));
}

export const channelConfigsOptions = () =>
	queryOptions({
		queryKey: channelsKeys.configs(),
		queryFn: async () => {
			const res = await listChannelConfigs();
			return res.configs ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function useChannelConfigs() {
	return useQuery(channelConfigsOptions());
}
